import globals from "@homer.core/globals";
import core from "@homer.core/api";
import isObject from "@homer.utility/validator.isobject";
import querystringEncode from "@homer.utility/querystring.encode";
import jsonStringify from "@homer.task/json.stringify";

const matchMethod = /^(?:POST|PUT|DELETE|PATCH)$/;
const flag = {
    isCacheable: Math.pow(2, 1),
    attachClienthints: Math.pow(2, 3),
};

export default class Request extends core.Request {
    constructor(method, data, header, flags = 0, client) {
        if (data && !isObject(data)) {
            throw new TypeError("Argument `data` must be of type `Object`");
        }

        data = data || {};
        header = header || {};

        const hasBody = matchMethod.test(method);

        super(method, data, {
            ...header,
            "Content-Type": hasBody ? "application/json" : undefined,
        });

        this.header = Promise.resolve(this.header);
        this.data = Promise.resolve(this.data);
        this.flags = flags;

        this.header = this.header.then((header) => {
            const modifier = [];

            if (!!(flags & flag.attachClienthints)) {
                modifier.push(
                    globals.demand.request("@homer.core/client.hints").then(async ([clientHints]) => {
                        if (clientHints) {
                            header["x-client-hints"] = await jsonStringify.execute(clientHints);
                        }
                    }),
                );
            }

            return Promise.all(modifier).then(() => header);
        });

        this.data = this.data.then((data) => {
            if (data) {
                return hasBody ? jsonStringify.execute(data) : querystringEncode(data);
            }

            return data;
        });
    }

    static flag = Object.freeze(flag);
}
